module.exports = __webpack_public_path__ + "img/time_standing.c8795cad.svg";